import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SlotControllerLegacy } from '../../controllers/slot-controller-legacy';
import { MobileControllerLegacy } from '../../controllers/mobile-controller-legacy';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import innerCSS from './se-basic-hero.inner.pcss?inline';
import '../outline-icon/outline-icon';
import '../se-background/se-background';
import '../se-button/se-button';
import '../se-container/se-container';
import '../se-heading/se-heading';

/**
 * The SeBasicHero component
 * @element se-basic-hero
 */
@customElement('se-basic-hero')
export class SeBasicHero extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });
  mobileControllerLegacy = new MobileControllerLegacy(this);
  slots = new SlotControllerLegacy(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );

  @property({ type: String })
  heading: string;

  @property({ type: String })
  description: string;

  @property({ type: String, attribute: 'cta-text' })
  ctaText: string;

  @property({ type: String, attribute: 'cta-url' })
  ctaUrl: string;

  render(): TemplateResult {
    return html`
      <section class="se-basic-hero">
        <se-background
          variant="curves"
          alignment="right"
          color="primary-1"
          full-bleed
        >
          <se-container>
            <div class="se-basic-hero--content">
              <se-heading class="se-basic-hero--heading" level="h1"
                >${this.heading}</se-heading
              >
              <span class="se-basic-hero--description"
                >${this.description}</span
              >
              ${this.ctaTemplate()}
            </div>
          </se-container>
        </se-background>
      </section>
    `;
  }

  ctaTemplate() {
    if (this.ctaUrl) {
      return html`
        <se-button
          button-url=${this.ctaUrl}
          button-target="_blank"
          variant="tertiary"
          button-label="${this.ctaText}"
          button-size="medium"
        >
          <outline-icon
            slot="right"
            size="1em"
            name="arrow-right"
            library="system"
            color="brand-secondary-1"
          ></outline-icon>
          ${this.ctaText}
        </se-button>
      `;
    } else {
      return null;
    }
  }
}
